import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseCollectionResult } from '@hooks/dashboard/useCollection'
import { HYGIENE_PLACEHOLDER } from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { FinanceMetricTileGrid } from '../../FinanceMetricTiles.component'
import { dashboardFinanceMetricFooter } from '../shared/dashboardFinanceMetricFooter'

type CollectionRatioCardProps = {
  titleHref: string
  collection: UseCollectionResult
}

export function CollectionRatioCard({
  titleHref,
  collection,
}: CollectionRatioCardProps): React.ReactElement {
  const {
    loading,
    hasPayload,
    hasPayerSplitData,
    hasDaysToCollectData,
    summary,
    patientStr,
    insuranceStr,
    patientDaysStr,
    insuranceDaysStr,
    patientCollectionGoalLabel: goalLabel,
    insuranceCollectionGoalLabel: insuranceGoalLabel,
    patientDaysGoalLabel: dsoGoalLabel,
    insuranceDaysGoalLabel: insuranceDsoGoalLabel,
  } = collection
  const isAmountsEmpty = shouldShowDashboardSectionEmpty(
    loading,
    hasPayerSplitData,
  )
  const isDaysEmpty = shouldShowDashboardSectionEmpty(
    loading,
    hasDaysToCollectData,
  )
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <div className="dashboard-finance-collection-ratio-column">
      <DashboardSectionCard
        title="Collection ratio"
        titleHref={titleHref}
        className="dashboard-finance-collection-ratio-card"
        loading={pending}
        skeleton={{ metrics: 2, block: 'none' }}
        isEmpty={isAmountsEmpty}
      >
        <FinanceMetricTileGrid
          columns={2}
          items={[
            {
              leftLabel: 'Patient',
              value: loading ? HYGIENE_PLACEHOLDER : patientStr,
              rightLabel: goalLabel,
              footer: summary
                ? dashboardFinanceMetricFooter(summary.patientCollection)
                : undefined,
            },
            {
              leftLabel: 'Insurance',
              value: loading ? HYGIENE_PLACEHOLDER : insuranceStr,
              rightLabel: insuranceGoalLabel,
              footer: summary
                ? dashboardFinanceMetricFooter(summary.insuranceCollection)
                : undefined,
            },
          ]}
        />
      </DashboardSectionCard>

      <DashboardSectionCard
        title="Collection ratio"
        titleHref={titleHref}
        className="dashboard-finance-collection-ratio-card"
        loading={pending}
        skeleton={{ metrics: 2, block: 'none' }}
        isEmpty={isDaysEmpty}
      >
        <FinanceMetricTileGrid
          columns={2}
          items={[
            {
              leftLabel: 'Patient',
              value: loading ? HYGIENE_PLACEHOLDER : patientDaysStr,
              rightLabel: dsoGoalLabel,
            },
            {
              leftLabel: 'Insurance',
              value: loading ? HYGIENE_PLACEHOLDER : insuranceDaysStr,
              rightLabel: insuranceDsoGoalLabel,
            },
          ]}
        />
      </DashboardSectionCard>
    </div>
  )
}
